<template>
  <el-dialog
      v-bind:model-value="visible"
      :title="dialogTitle"
      class="modal-95-70-60"
      @close="handleClose"
  >
    <el-tabs v-model="activeTab" class="inside-tabs">
      <el-tab-pane v-if="allowUsersEditing" label="Пользовательские данные" name="userdata">
        <SubuserEditForm ref="subuserForm" v-model="userdata"/>
      </el-tab-pane>
      <el-tab-pane v-if="allowSetupRestrictions" label="Ограничения доступа" name="restrictions">
        <LoginRestrictions ref="loginRestrictions"/>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">Отмена</el-button>
        <el-button type="success" :loading="saving" @click="saveSubuser()" data-test="saveUser">Сохранить</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import SubuserEditForm from "./tabs/subuser-edit-form.component"
import LoginRestrictions from "./tabs/restrictions.component"

export default {
  name: "SubuserEditDialog",
  components: {SubuserEditForm, LoginRestrictions},
  props: [
    "visible",
    "user",
    "editMode",
    "savePath",
    "roles",
      "allowUsersEditing",
      "allowSetupRestrictions"
  ],
  emits: ['update:visible'],
  updated() {
    this.setUser(this.user)
  },
  computed: {
    dialogTitle() {
      return this.editMode ? 'Редактировать пользователя' : 'Добавить пользователя'
    },
    activeTab(){
      return this.allowUsersEditing ? "userdata" : "restrictions"
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false)
      // if (this.editMode) {
      //   this.$refs.subuserForm.resetPasswordFields()
      // }
      // this.$refs.loginRestrictions.reset()
      this.activeTab = "userdata"
    },
    async setUser(user) {
      this.userdata.editMode = this.editMode
      this.userdata.roles = this.roles

      this.userdata._id = this.editMode ? user?._id || "" : ""
      this.userdata.system_id = this.editMode ? user?.system_id || "" : ""


      this.userdata.role = user?.privilege_role || ""
      this.userdata.surname = user?.info.lastname || ""
      this.userdata.name = user?.info.firstname || ""
      this.userdata.patronymic = user?.info.patronymic || ""
      this.userdata.phone = user?.info.phone || ""
      this.userdata.email = user?.info.email || ""

      this.userdata.password = ""
      this.userdata.passwordConfirm = ""

      await this.$nextTick()
      if(this.$refs.loginRestrictions) {
        if (user) {
          this.$refs.loginRestrictions.setRules(user.ip_access)
        } else {
          this.$refs.loginRestrictions.reset()
        }
      }
    },
    async saveSubuser() {
      let valid = await this.$refs.subuserForm.validate()
      if (valid) {
        let loginRestriction = this.$refs.loginRestrictions.getRules()
        let data = {
          ...this.userdata,
          sendProfileBy: this.sendProfileBy,
          loginRestriction
        }
        delete data.roles
        delete data.editMode
        try {
          this.saving = true
          let resp = await this.axios.post(this.savePath, {data})
          if (resp.data.error) {
            let {error} = resp.data
            if (error === "duplicateEmail") {
              this.$gNotify("Такой email уже используется", "error")
            }
            if (error === "duplicatePhone") {
              this.$gNotify("Такой  номер телефона уже  используется", "error")
            }
          } else {
            this.$gNotify(`Пользователь ${this.editMode ? 'обновлён' : 'добавлен'}`, "success")
            this.handleClose()
            this.$emit("refresh")
          }
        } catch (e) {
          console.error(e)
        } finally {
          this.saving = false
        }
      } else {
        this.activeTab = "userdata"
      }
    }
  },
  data() {

    return {
      sendProfileBy: ["email"],
      userdata: {},
      saving: false
    }
  }
}
</script>